import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Launch } from './pages/Launch';
import { Competitors } from './pages/Competitors';
import { Story } from './pages/Story';
import { Investors } from './pages/Investors';
import { Expectations } from './pages/Expectations';
import { Agreement } from './pages/Agreement';
import { ScrollToTop } from './components/ScrollToTop';
import { LanguageProvider } from './i18n/LanguageContext';
import { LanguageSwitcher } from './components/LanguageSwitcher';
export function App() {
  return <LanguageProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <LanguageSwitcher data-id="element-3" />
        <Routes data-id="element-4">
          <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
          <Route path="/launch" element={<Launch data-id="element-8" />} data-id="element-7" />
          <Route path="/competitors" element={<Competitors data-id="element-10" />} data-id="element-9" />
          <Route path="/story" element={<Story data-id="element-12" />} data-id="element-11" />
          <Route path="/investors" element={<Investors data-id="element-14" />} data-id="element-13" />
          <Route path="/expectations" element={<Expectations data-id="element-16" />} data-id="element-15" />
          <Route path="/agreement" element={<Agreement data-id="element-18" />} data-id="element-17" />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>;
}